var COOKIE_LENGTH = 16;
export function getCookie(key) {
    return document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + key + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1');
}
export function setCookie(key, value, expires, path, domain, secure) {
    // blue/store/enumerable/cookie
    if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
        return false;
    }
    var stdExpire = '';
    if (expires) {
        switch (expires.constructor) {
            case Number:
                stdExpire = expires === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + expires;
                break;
            case String:
                stdExpire = '; expires=' + expires;
                break;
            case Date:
                stdExpire = '; expires=' + expires.toUTCString();
                break;
        }
    }
    document.cookie = key + '=' + value + stdExpire + (domain ? '; domain=' + domain : '') + (path ? '; path=' + path : '') + (secure ? '; secure' : '');
    return true;
}
;
export var getCookieEachKeyValue = function (cookieValue, key) {
    var suffixKey = /\|(([\w&.\-]+\.)?([\w&.\-]+\.)?(\*|[\w&.\-]+))(?=$|\|)/;
    var regex = key + suffixKey.source;
    var match = cookieValue.match(regex);
    return match && match[1] || '';
};
export function hashCode(data) {
    var hash = 0;
    if (data !== undefined) {
        data = data.toString();
        for (var i = 0; i < data.length; i++) {
            var chr = data.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash = (hash & hash);
        }
    }
    return hash;
}
